import './EditDropdownMenu.scoped.sass'
import modalService from '@/services/modal.service'

import { ReactComponent as BackIcon } from '@/assets/icons/reply-icon.svg'
import { ReactComponent as PencilIcon } from '@/assets/icons/pencil-icon-2.svg'
import { ReactComponent as ArchiveIcon } from '@/assets/icons/archive-solid.svg'
import { AddBoxModalContainer } from '../../AddBoxModalContainer/AddBoxModalContainer'
import DropdownService from '@/components/DropdownMenu/dropdown.service'
import { useEffect } from 'react'
import boxesService from '@/app-domains/boxes/boxes.service'

export function EditDropdownMenu ({ box, event }) {
  const iconSize = { width: '18px', height: '18px' }

  const menuOptions = [
    {
      icon: <PencilIcon style={iconSize} />,
      title: 'Edit',
      action: () => {
        DropdownService.close()
        modalService.open(<AddBoxModalContainer box={box} closeAddLabelModal={() => modalService.close()} />)
      },
      color: 'normal'
    },
    {
      separator: true,
    },
    {
      icon: box.archived ? <BackIcon style={iconSize}/> : <ArchiveIcon style={iconSize}/>,
      title: box.archived ? 'Unarchive' : 'Archive',
      action: () => {
        DropdownService.close()
        boxesService.toggleArchivedBox(box.composedid)
          .then(() => {})
          .catch((err) => {
            throw new Error(err)
          })
      },
      color: 'red'
    },
  ]

  useEffect(() => {
    DropdownService.open(menuOptions, 'right', event)
  }, [])

  return <></>
}
